/**
 * Az első karaktert uppercaseli.
 * @template {string} T
 * @param {T} str - A szöveg.
 * @returns {Capitalize<T>} Az átalakított szöveg.
 */
function ucFirst (str) {
  /* @ts-expect-error Jó ez. */
  return `${ str.charAt(0).toUpperCase() }${ str.slice(1) }`
}

module.exports.ucFirst = ucFirst
